
























import { Vue, Prop, Component } from "vue-property-decorator";
import { mapState } from "vuex";
import { IState } from "@/store";
import { IMenuRoute } from "@/models/routes";
import { IUser } from "@/models/users";

@Component({
  computed: {
    ...mapState({
      user: (state: IState) => state.user
    })
  }
})
export default class AdminAccount extends Vue {
  // Props
  @Prop({ default: () => () => [] })
  public readonly routes!: () => IMenuRoute[];

  // Bindings
  public user!: IUser;

  // Methods
  public mounted() {
    this.$bus.$emit("scrollToTop");
  }
}
